export default __webpack_public_path__ + "static/media/ic-time.6a743e96.svg";